import { MARQUEE_ITEMS } from "@/data/static";

export const Marquee = ({ items = MARQUEE_ITEMS, dark = true }) => {
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden py-5 border-y ${dark ? "bg-brand-burgundy border-brand-gold/25" : "bg-brand-paper border-brand-gold/30"}`}
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-cinzel text-sm sm:text-base tracking-[0.25em] ${dark ? "text-brand-cream/90" : "text-brand-burgundy"}`}>
              {item}
            </span>
            <span className="mx-8 text-brand-gold text-xs">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
